import { makeStyles } from 'tss-react/mui';
import { red } from '@mui/material/colors';

export default makeStyles()(theme => ({
    root: {
        maxHeight: '60px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: `${theme.spacing(1, 2)} !important`
    },
    buttonClear: {
        color: red[300]
    }
}));